import PathTemplatePattern from "./PathTemplatePattern";
import PathPlanFallDown from "../plan/PathPlanFallDown";
import Path from "../Path";

// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternFallDown3 extends PathTemplatePattern {
    constructor() {
        super([
            'S',        // start
            '8',        // o|p
            '8',        // o|p
            'E'         // end
        ],
        false);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 3;
    }
    
    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol();
        const targetRow = start.getTileRow() + 3;  // end tile is 2 rows below start

        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);
        if (endIndex < 0) {
            return null;
        }
        
        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;
        return new PathPlanFallDown(start, end, steps);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol();
        const targetRow = start.getTileRow() + 3;  // end tile is 2 rows below start

        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;
        return new PathPlanFallDown(start, end, steps);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternFallDown3';
    }
}